import styled from 'styled-components'
import { Colors, Utils } from '@microfrontends/react-components'

const IMAGE_SERVICE = process.env.IMAGE_BASE_URL + '/images/career-path'
const TABLET_SCREEN = 1024

export const BannerContainer = styled.div`
	position: relative;
	height: 562px;
	background: ${Colors.primary};
	background-image: url(${IMAGE_SERVICE + '/banner-background.png'});
	background-size: contain;
	background-repeat: no-repeat;
	background-position: bottom;
	@media (max-width: ${TABLET_SCREEN}px) {
		height: auto;
	}
`

export const ObjectWrapper = styled.div`
	position: absolute;
	width: 787px;
	height: 100%;
	right: 0;
	overflow: hidden;
	@media (max-width: ${TABLET_SCREEN}px) {
		position: relative;
		width: 100%;
		height: 420px;
		display: flex;
		align-items: end;
	}
`
export const Object1 = styled.img`
	object-position: 0 50px;
	opacity: 0.3;
	@media (max-width: ${TABLET_SCREEN}px) {
		width: 100%;
		object-position: bottom;
	}
`
export const Object2 = styled.img`
	position: absolute;
	bottom: 0;
	left: 50%;
	transform: translateX(-50%);
	width: 550px;
	@media (max-width: ${TABLET_SCREEN}px) {
		width: 436px;
	}
	right: 220px;
`
/* bottom: 0; */

export const Wrapper = styled.div`
	padding-top: 30px;
	position: absolute;
	z-index: 1;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	@media (max-width: ${TABLET_SCREEN}px) {
		position: static;
	}
`

export const Heading = styled.h1`
	position: relative;
	font-family: 'Dela Gothic One';
	color: #fff;
	margin: 0;
	font-size: 60px;
	white-space: pre-line;
	width: fit-content;
	line-height: 1.2;
	& .highlight {
		color: ${Colors.button};
	}
	& > .text {
		margin-bottom: 0;
	}
	@media (max-width: ${Utils.screens.mobile}px) {
		font-size: 45px;
		white-space: unset;
	}
`

export const List = styled.ul``
export const Item = styled.li``
